import React, {} from 'react'
import {Redirect} from 'react-router-dom'

const Company = () => <Redirect to={'/company/usestatus/usedetail'}/>;

export default Company;
